// hooks/useTheme.js - FIXED VERSION med imports på toppen
import { useState, useEffect, createContext, useContext } from 'react';
import { colorThemes, injectCSSVariables } from '../colors/theme';

export const useTheme = () => {
  const [currentTheme, setCurrentTheme] = useState('default');

  // Last valgt tema ved oppstart
  useEffect(() => {
    const savedTheme = localStorage.getItem('selectedTheme') || 'default';
    changeTheme(savedTheme);
  }, []);

  // Bytt tema - ENESTE STED DU TRENGER Å ENDRE FARGER
  const changeTheme = (themeName) => {
    if (!colorThemes[themeName]) {
      console.warn(`Theme "${themeName}" not found, using default`);
      themeName = 'default';
    }

    setCurrentTheme(themeName);
    
    // Lagre valg
    localStorage.setItem('selectedTheme', themeName);
    
    // AUTOMATISK oppdatering av CSS variabler
    injectCSSVariables(themeName);
  };

  // Hent informasjon om tilgjengelige temaer
  const getThemeInfo = () => {
    return Object.entries(colorThemes).map(([key, theme]) => ({
      id: key,
      name: theme.name,
      description: theme.description,
      preview: [
        theme.colors.primary[500],
        theme.colors.accent[500], 
        theme.colors.secondary[500]
      ]
    }));
  };

  // Hent spesifikk farge fra aktivt tema (for JS bruk)
  const getColor = (colorName, shade = 500) => {
    const theme = colorThemes[currentTheme];
    return theme?.colors[colorName]?.[shade] || '#ec4899';
  };

  return {
    currentTheme,
    availableThemes: Object.keys(colorThemes),
    themeInfo: getThemeInfo(),
    changeTheme,
    getColor
  };
};

// React Context for å dele tema i hele appen (valgfritt)
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const theme = useTheme();
  
  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within ThemeProvider');
  }
  return context;
};

export default useTheme;